import React from "react"
import { Accordion } from "devextreme-react"
import { Item as AccordionItem } from "devextreme-react/accordion"

import { FaTable, FaChartBar } from "../../../fa-icons"
import PaymentGrid from "./PaymentGrid"
import PaymentChart from "./PaymentChart"
import { hasAccessTo } from "../../../authentication"
import { getAccordionState, setAccordionState } from "../../shared/utilities"

const Payment = ({ data }) => {
  const stateKey = "concur-payments"
  const paymentId = data.id

  return (
    <Accordion
      collapsible={true}
      multiple={true}
      onInitialized={getAccordionState(stateKey)}
      onSelectionChanged={setAccordionState(stateKey)}
    >
      <AccordionItem
        icon={FaChartBar}
        title=" Chart"
        visible={hasAccessTo("concur.payment.chart")}
      >
        <PaymentChart paymentId={paymentId} />
      </AccordionItem>
      <AccordionItem
        icon={FaTable}
        title=" Grid"
        visible={hasAccessTo("concur.payment.grid.r")}
      >
        <PaymentGrid paymentId={paymentId} />
      </AccordionItem>
    </Accordion>
  )
}

export default Payment
